import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getContactInformation,
  postVerificationForm,
  resetAllFormData,
  resetVerificationForm,
} from "../redux/actions";
import { useHistory } from "react-router-dom";
import Card from "../components/Card/Card";
import CardHeader from "../components/CardHeader/CardHeader";
import CustomButton from "../components/CustomButton/CustomButton";
import BackButton from "../components/BackButton/BackButton";
import theme from "../theme/theme";
import styled from "styled-components";
import LoadingBar from "../components/LoadingBar/LoadingBar";
import { SET_LOADING } from "../redux/action-types";
import Header from "../components/Header";

const BodyWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: 630px) {
    margin: 15px;
  }

  .mainContainer {
    width: 70%;
  }

  .subtitle {
    color: ${theme.colors.black1};
  }

  .title {
    margin-top: 2em;
    font-size: 18px;
    color: ${theme.colors.black};
  }

  .informationContainer {
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    &__name {
      font-weight: 600;
      color: ${theme.colors.black1};
    }
  }

  .buttonBackContainer {
    margin: 1em 0.5em;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    & span:nth-child(1) {
      padding: 0px;
    }

    & span:nth-child(2) {
      font-size: 32px;
    }
  }

  @media (max-width: 630px) {
    .mainContainer {
      width: 100%;
    }
  }

  .informationContainer__block {
    display: flex;
    margin-bottom: 10px;
    @media (max-width: 630px) {
      flex-direction: column;
    }

    & p {
      margin: 5px;
    }
  }

  .informationContainer__name {
    width: 45%;
    @media (max-width: 630px) {
      width: 100%;
    }
  }

  .informationContainer__value {
    @media (max-width: 630px) {
      width: 100%;
    }
  }
`;

const ReviewJointForm = () => {
  const categories = [
    {
      name: "Email",
      value: "email",
    },
    {
      name: "Marital Status",
      value: "maritalStatus",
    },
    {
      name: "Number of Dependents",
      value: "numDependents",
    },
    {
      name: "Country of Birth",
      value: "countryOfBirth",
    },
    {
      name: "Country of Legal Residence",
      value: "legalResidenceCountry",
    },
    {
      name: "State of Legal Residence",
      value: "legalResidenceState",
    },
  ];

  const jointCategories = [
    {
      name: "Country of Tax Residency",
      value: "residenceCountry",
    },
    {
      name: "State of Tax Residency",
      value: "residenceState",
    },
  ];

  const additionalCategories = [
    {
      name: "Country of Tax Residency",
      value: "residencyContry",
    },
    {
      name: "State of Tax Residency",
      value: "residencyState",
    },
  ];

  const dispatch = useDispatch();
  const history = useHistory();
  const {
    setGoalToLaunchPayLoad,
    loading,
    jointInformation,
    userAccountDetails,
  } = useSelector((state) => state.user);
  const [isLoaded, setIsLoaded] = useState(true);

  const actualGoalId = setGoalToLaunchPayLoad?.goalId;

  useEffect(() => {
    dispatch(resetVerificationForm());
    if (loading) {
      setIsLoaded(false);
    }
  }, [dispatch, loading]);

  useEffect(() => {
    dispatch(getContactInformation(actualGoalId));
    dispatch({ type: SET_LOADING, payload: true });
  }, [actualGoalId, dispatch]);

  useEffect(() => {
    if (jointInformation && userAccountDetails) {
      dispatch({ type: SET_LOADING, payload: false });
    }
  }, [dispatch, jointInformation, userAccountDetails]);

  const handleSubmitButtonClick = (goalId) => {
    dispatch(postVerificationForm(goalId));
    dispatch(resetAllFormData());
    history.push("/verification-form/joint");
  };
  return (
    <>
      {(!isLoaded || loading) && (
        <LoadingBar isLoading={loading} setIsLoaded={setIsLoaded} />
      )}
      <Header />
      <BodyWrapper>
        <div className="mainContainer">
          <Card>
            <CardHeader text={"Review & Confirm Your Details"} />
            <p className="subtitle">
              Please review and confirm the details below to begin creating your
              trading account.
            </p>
            <h1 className="title">Personal Information</h1>
            <div className="informationContainer">
              <div className="informationContainer__block">
                <p className="informationContainer__name">Name</p>
                <p className="informationContainer__value">
                  {jointInformation?.firstName}, {jointInformation?.lastName}
                </p>
              </div>
              {categories.map((category) => (
                <>
                  <div className="informationContainer__block">
                    <p className="informationContainer__name">
                      {category.name}
                    </p>
                    <p className="informationContainer__value">
                      {jointInformation?.[category.value]}
                    </p>
                  </div>
                </>
              ))}
              {jointCategories.map((jointCategory) => (
                <>
                  <div className="informationContainer__block">
                    <p className="informationContainer__name">
                      {jointCategory.name}
                    </p>
                    <p className="informationContainer__value">
                      {jointInformation?.[jointCategory.value]}
                    </p>
                  </div>
                </>
              ))}
            </div>
            <h1 className="title">Additional Account Holder</h1>
            <div className="informationContainer">
              <div className="informationContainer__block">
                <p className="informationContainer__name">Name</p>
                <p className="informationContainer__value">
                  {jointInformation?.additionalAccountHolder?.firstName},{" "}
                  {jointInformation?.additionalAccountHolder?.lastName}
                </p>
              </div>
              {categories.map((category) => (
                <>
                  <div className="informationContainer__block">
                    <p className="informationContainer__name">
                      {category.name}
                    </p>
                    <p className="informationContainer__value">
                      {
                        jointInformation?.additionalAccountHolder?.[
                          category.value
                        ]
                      }
                    </p>
                  </div>
                </>
              ))}
              {additionalCategories.map((additional) => (
                <>
                  <div className="informationContainer__block">
                    <p className="informationContainer__name">
                      {additional.name}
                    </p>
                    <p className="informationContainer__value">
                      {
                        jointInformation?.additionalAccountHolder?.[
                          additional.value
                        ]
                      }
                    </p>
                  </div>
                </>
              ))}
            </div>
          </Card>
          <div className="buttonBackContainer">
            <BackButton backLogo></BackButton>
            <CustomButton
              text="BEGIN"
              nextLogo
              onClick={() => handleSubmitButtonClick(actualGoalId)}
            />
          </div>
        </div>
      </BodyWrapper>
    </>
  );
};

export default ReviewJointForm;
